"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var React = require("react");

var reactstrap_1 = require("reactstrap");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var phone_1 = require("../../../utils/phone");

var palette_1 = require("../../../constants/palette");

var MobileAddress = styled_components_1.default.address(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 15px;\n  text-align: center;\n  font-style: normal;\n  color: ", ";\n  margin-top: 20px;\n  line-height: 1.3;\n"], ["\n  font-size: 15px;\n  text-align: center;\n  font-style: normal;\n  color: ", ";\n  margin-top: 20px;\n  line-height: 1.3;\n"])), palette_1.default.darkGrey);
var MobileButton = styled_components_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: transparent;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  color: ", ";\n  padding: 15px;\n  text-align: center;\n  text-decoration: none;\n  width: 100%;\n  display: block;\n"], ["\n  background-color: transparent;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  color: ", ";\n  padding: 15px;\n  text-align: center;\n  text-decoration: none;\n  width: 100%;\n  display: block;\n"])), palette_1.default.blue, palette_1.default.blue);
var MobileContactInfoDOM = styled_components_1.default.section(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 15px;\n"], ["\n  margin: 15px;\n"])));

var MobileContactButtons =
/** @class */
function (_super) {
  __extends(MobileContactButtons, _super);

  function MobileContactButtons(props) {
    var _this = _super.call(this, props) || this;

    _this.mapsSelector = _this.mapsSelector.bind(_this);
    return _this;
  }

  MobileContactButtons.prototype.mapsSelector = function () {
    var platform = navigator.platform;
    var _a = this.props,
        address1 = _a.address1,
        address2 = _a.address2,
        city = _a.city,
        state = _a.state,
        zip = _a.zip;

    if (platform.indexOf('iPhone') !== -1 || platform.indexOf('iPad') !== -1 || platform.indexOf('iPod') !== -1) {
      var address2String = address2 !== null ? "," + address2 : '';
      var formattedAddress = "" + address1 + address2String + "," + city + "," + state + "," + zip;
      window.open("http://maps.apple.com/?address=" + formattedAddress);
    } else {
      var address2String = address2 !== null ? "+" + address2 : '';
      var formattedAddress = "" + address1 + address2String + "+" + city + "+" + state + "+" + zip;
      window.open("https://maps.google.com/maps/place/" + formattedAddress);
    }
  };

  MobileContactButtons.prototype.render = function () {
    return React.createElement(reactstrap_1.Container, null, React.createElement(reactstrap_1.Row, null, React.createElement(reactstrap_1.Col, {
      xs: 6
    }, React.createElement(MobileButton, {
      href: "tel:" + this.props.phoneNumber
    }, React.createElement(react_fontawesome_1.FontAwesomeIcon, {
      icon: free_solid_svg_icons_1.faPhone,
      size: "lg"
    }))), React.createElement(reactstrap_1.Col, {
      xs: 6
    }, React.createElement(MobileButton, {
      href: '#',
      onClick: this.mapsSelector
    }, React.createElement(react_fontawesome_1.FontAwesomeIcon, {
      icon: free_solid_svg_icons_1.faMapMarkerAlt,
      size: "lg"
    })))));
  };

  return MobileContactButtons;
}(React.Component);

var MobileContactInfo = function MobileContactInfo(props) {
  return React.createElement(MobileContactInfoDOM, null, React.createElement(MobileContactButtons, __assign({}, props)), React.createElement(MobileAddress, null, props.address1, React.createElement("br", null), props.address2 && React.createElement("span", null, props.address2, React.createElement("br", null)), props.city, ", ", props.state, " ", props.zip, React.createElement("br", null), props.phoneNumber && phone_1.formatPhoneNumber(props.phoneNumber)));
};

exports.default = MobileContactInfo;
var templateObject_1, templateObject_2, templateObject_3;